import React from 'react'
import { getConfig, FrameIn, getBrand, trackPage, getOwaTcdaoContext } from '../twd/twd'
import "./orders.css"
import { Accounts } from './accounts'
import { Filters } from './filters'
import { Grid as Blotter } from './blotter'
import { Footer } from './footer'
import { ContextProvider } from './use-orders'

export default (args) => {
    trackPage('orders')

    if (getConfig('entitlements.ETradeViewOrders', 'No') === 'Yes') {
        return <Main {...args} />
    }

    return <React.Fragment>
        <div className="container">
        <div className="row vertical-offset-lg">
        <div className="col-md-12 col-xs-12 bottom-border">
        <FrameIn
            dataName="orders-frame"
            src={ `${getConfig('bw_service_host')}/${getBrand()}/${getOwaTcdaoContext()}/pkg_blotter_bond.order_status_output?p_first_time=Y` }
        />
        </div>
        </div>
        </div>
        </React.Fragment>
}

const Main = (args) => {

    return <React.Fragment>
        <div className="container view-orders">

        <div className="row"><div className="col-xs-12">
        <div data-name="messages-message"
            className="universal-message universal-message-info universal-message-dismissible"
            role="alert">
            <div data-name="messages-message-content"
                className="universal-message-content"
                style={{width:'100%'}}
            >
            Cancel requests for open Treasury Auction orders must be submitted prior to 9 a.m. ET;
            cancellation of an order is not guaranteed even if submitted prior to 9 a.m. ET.
            Please consult your E*TRADE from Morgan Stanley Client Agreement for Self-Directed Accounts for further information on order cancellations.
            </div>
        </div>
        </div></div>

        <div className="row vertical-offset-xs">
        <div className="col-md-12 col-xs-12">
            <h2 className="large-header">View Orders</h2>
        </div>
        </div>
        <ContextProvider {...args}>
            <Accounts />
            <Filters  />

            <div className="row vertical-offset-xs">
            <div className="col-md-12 col-xs-12">
                <Blotter />
            </div>
            </div>
        </ContextProvider>
        </div>

        <Footer />
        </React.Fragment>
}
